module.exports = __webpack_public_path__ + "static/media/768-products---5-image-3.5a746dd2.png";